import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import FooterContainer from '../../../components/FooterContainer/FooterContainer';
import styles from './Banner.module.scss';
import Button from '../../../elements/Button/Button';
import { ApiInformation } from '../../../api/portal/portalApi';
import { loadAPiList } from '../../apis/APIUtil';
import { ReactComponent as SignInIcon } from '../../../styles/icon/sign-in-landing-page.svg';
import { getFlagProperty } from '../../../redux/flags/flags';
import { TriggerOnScroll } from '../../../elements';
import strings from '../../../lang/lang';

import BannerImages from './BannerImages';
import Apis from './Apis';
import {keycloak} from "../../../keycloak-config";

const mapStateToProps = (state) => {
  return {
    isPageAnimationsUnblocked: getFlagProperty(state, 'isPageAnimationsUnblocked'),
  };
};

function LandingMainCard(props) {
  const head = strings.landingPage.landingMainCard.text.title;
  const desc = strings.landingPage.landingMainCard.text.description;
  const [apiList, setApiList] = useState<Array<ApiInformation>>([]);
  const { isPageAnimationsUnblocked, history } = props;

  useEffect(() => {
    loadAPiList({setApiList, history}).finally();
  }, [history]);

  return (
    <div>
      <div className={styles.banner}>
        <div className={styles.banner__container}>
          <TriggerOnScroll bypass={!isPageAnimationsUnblocked} topOffset="10%">
            <div className={styles.banner__box}>
              <h1>{head}</h1>
              <p>{desc}</p>
            </div>
          </TriggerOnScroll>
          <TriggerOnScroll bypass={!isPageAnimationsUnblocked} topOffset="10%">
            <div
              className={cn(styles.banner__buttons, {
                'hide-buttons': keycloak.authenticated,
              })}
            >
              <a href={keycloak.createRegisterUrl()}>
                <Button name={strings.landingPage.landingMainCard.buttons.signUp} variant="gradient_none" className="btn-banner-up" />
              </a>
              <a href={keycloak.createLoginUrl()}>
                <Button name={strings.landingPage.landingMainCard.buttons.signIn} variant="gradient" className="btn-banner-in">
                  <SignInIcon />
                </Button>
              </a>
            </div>
          </TriggerOnScroll>
          <BannerImages
            isPageAnimationsUnblocked={isPageAnimationsUnblocked}
          />
        </div>
      </div>
      <Apis apiList={apiList} isPageAnimationsUnblocked={isPageAnimationsUnblocked} />
      <FooterContainer />
    </div>
  );
}

export default connect(mapStateToProps)(LandingMainCard);
